import Cookies from 'js-cookie'

// Age Gate formc/cookie/"session" functionality
(function($) {
    const cookieName = 'hover_remember'

    const whitelisted = [
        HOVER.page_url.age_gate,
        HOVER.page_url.hover_usa,
        HOVER.page_url.privacy,
        HOVER.page_url.terms
    ]

    // check if current page is in the list of whitelisted pages
    let redirectToGate = whitelisted.indexOf(window.location.pathname) === -1
    const cookie = Cookies.get(cookieName)

    // Privacy Policy and Terms & Conditions pages are whitelisted
    // only in case of user visiting them from the AGE GATE page
    // otherwise, they behave the same as any other page (gated without cookie)
    if (
        (
            HOVER.page_url.privacy === window.location.pathname ||
            HOVER.page_url.terms === window.location.pathname
        ) && $('.header__menu').length) {
        redirectToGate = true
    }

    // Redirect to Age Gate if the cookie isn't found
    // or this page isn't whitelisted
    if (!cookie && redirectToGate) {
        window.location = HOVER.page_url.age_gate
    }

    // Form functinality
    const form = $('.age-gate__mid')
    const buttons = $('.age-gate__actions > button')
    const denied = form.find('.age-gate__denied')

    if (!form.length) {
        return false
    }

    buttons.on('click', function(e) {
        e.preventDefault()
        const val = $(this).data('value')

        if (val === 'yes') {
            const remember = form.find('input[type="checkbox"]').is(':checked')

            // https://github.com/js-cookie/js-cookie/wiki/Frequently-Asked-Questions#how-to-make-the-cookie-expire-in-less-than-a-day
            // expires in 30 days if remember me checkbox is selected
            // or one hour from now if not
            Cookies.set(cookieName, true, {
                expires: remember ? 30 : 1 / 24
            });

            form.submit()
        } else {
            denied.show()
        }
    })

    denied.on('click', 'button', function() {
        denied.hide()
    })
})(jQuery)
